<template>
    <div id="EditProfileDiv">
      <HeaderVue isHeader="true"/>
      <div class="inner-page phleb-signup my-profile">
          <div class="inner-page phleb-signup my-profile">
              <div class="container">
                  <div class="row">
                      <div class="col align-self-center">
                           <form data-vv-scope="password">
                              <div class="sign-up change-password">
                                  <div class="signup-title">
                                      <h4 class="mt-0 mb-0">Changes Password</h4>
                                  </div>
                                  <div class="form-content line-textbox">
                                      <p class="no-mar-top red-color" v-if="error">{{errormsg}}</p>
                                      <div class="form-group">
                                          <label>Type Current Password</label>
                                          <input class="form-control" type="password" name="oldPassword" data-vv-as="current password" v-model="oldPassword" v-validate="'required'">
                                          <span v-show="errors.has('password.oldPassword')" class="text-danger">{{ errors.first('password.oldPassword') }}</span>
                                      </div>
                                      <div class="form-group">
                                          <label>Type New Password</label>
                                          <input class="form-control" type="password" name="newPassword" data-vv-as="new password" v-model="newPassword" v-validate="'required'">
                                          <span v-show="errors.has('password.newPassword')" class="text-danger">{{ errors.first('password.newPassword') }}</span>
                                      </div>
                                      <div class="form-group">
                                          <label>Retype New Password</label>
                                          <input class="form-control" type="password" name="confirmPassword" data-vv-as="retype new password" v-model="confirmPassword" v-validate="'required'">
                                          <span v-show="errors.has('password.confirmPassword')" class="text-danger">{{ errors.first('password.confirmPassword') }}</span>
                                          <span v-show="confirmPassword !== '' && newPassword !== confirmPassword" class="text-danger">The retype new password confirmation does not match</span>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-sm-4">
                                          <router-link to="/myprofile"><button class="btn btn-link">Cancel</button></router-link>
                                      </div>
                                      <div class="col-sm-8">
                                          <button class="btn btn-primary full-width" :disabled="(errors.any())" @click.prevent="savePassword()">Change Password</button>
                                      </div>
                                  </div>
                              </div>
                           </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'

export default {
  name: 'ChangePassword',
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
  },
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: false,
      errormsg: ''
    }
  },
  methods: {
    savePassword: function () {
      this.$validator.validateAll('password').then((result) => {
        if (result) {
          try {
            this.error = false
            this.errormsg = ''
            var data = {
              'oldPassword': this.oldPassword,
              'newPassword': this.newPassword
            }
            Promise.resolve(this.$POST('patient/changePassword', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$router.push({ path: '/myprofile' })
              } else {
                this.error = true
                this.errormsg = res.response_message
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.error('method:save_password', e)
          }
        }
      })
    }
  },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Secure/ChangePassword.vue